export const formatServiceName = (slug: string): string => {
    const specialCases: Record<string, string> = {
        att: "AT&T",
        aws: "AWS",
        opendns: "OpenDNS",
        "t-mobile": "T-Mobile",
        "us-cellular": "UScellular",
        whatsapp: "WhatsApp",
    };

    if (specialCases[slug]) {
        return specialCases[slug];
    }

    return slug
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};
